import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ElementSVC } from './element-svc';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ElementSVC {

  api = environment.apiurl;

  constructor(protected override http: HttpClient) {
    
    super(http);
    this.apiurl += '/users';

  }

  registerUser(element){
    return this.http.put(this.apiurl + '/new', element);
  }

  getEmployeeUser(filter?: string){
    return this.http.get(this.api + '/employees' + (filter!=undefined ? '?' + filter : ''));
  }

  getEmployeeRental(filter?: string){
    return this.http.get(this.apiurl + '/rental' + (filter!=undefined ? '?' + filter : ''));
  }

  getWorkerUser(filter?: string){
    return this.http.get(this.api + '/workers' + (filter!=undefined ? '?' + filter : ''));
  }
  
  getAbsencesUser(iduser, filter?: string){
    return this.http.get(this.apiurl + '/' + iduser + '/absences' + (filter!=undefined ? '?' + filter : ''));
  }

  getQualificationUser(iduser, filter?: string){
    return this.http.get(this.apiurl + '/' + iduser + '/qualifications' + (filter!=undefined ? '?' + filter : ''));
  }

  searchUsers(searchparam){
    
    return this.http.get(this.apiurl + '/searchbyworkparams', {params: searchparam});
    
  }

  searchUsersNoRental(searchparam){
    
    return this.http.get(this.apiurl + '/searchbyworkparamsnorental', {params: searchparam});
    
  }

  getSingleWorkPeriods(iduser, start, end){
      
    return this.http.get(this.apiurl + '/' + iduser + '/work-periods' + '?start=' + start + '&end=' + end);
  
  }

  getWorkPeriods(start, end)
  {
      
    return this.http.get(this.apiurl + '/work-periods' + '?start=' + start + '&end=' + end);
  
  }

  getSingleAbsencesPeriods(iduser, start, end){
      
    return this.http.get(this.apiurl + '/' + iduser + '/absences-periods' + '?start=' + start + '&end=' + end);
  
  }

  deleteMedia(iduser: number, idmedia: number){

    return this.http.delete(this.apiurl + '/'+ iduser + '/media/' + idmedia);

  } 

}
